<template lang="pug">
#report-account-transactions
    v-banner.title-banner(min-height="88")
        .text-h4.font-weight-bold {{ $t('Menu.__Report') }} : {{ $t('Reports.__AccountBalances') }}
        //- template(v-slot:actions)
        //-     v-btn.my-2.ml-4(rounded dark @click="downloadReport" color="primary") 
        //-         | {{$t('ActionOption.__Export')}}
    v-container
        v-card(color="#fdf1eb", elevation="0")
            v-card-text
                v-form(v-model="formValid", ref="reportform")
                    v-row
                        v-col(cols="12", md="3")
                            DateRangeSelector(v-model="dateRangeSelect")
                            //- v-select(v-model="dateSelect" :items="dateItems" outlined dense solo hide-details)
                        v-col(cols="12", md="3")
                            v-menu(
                                v-model="rangeDateMenu",
                                offset-y,
                                :close-on-content-click="false",
                                :nudge-right="40",
                                transition="scale-transition",
                                min-width="290px"
                            )
                                template(v-slot:activator="{ on }")
                                    v-text-field(
                                        :value="dateRangeText",
                                        clearable,
                                        hide-details,
                                        solo,
                                        dense,
                                        outlined,
                                        readonly,
                                        append-icon="event",
                                        v-on="on",
                                        :placeholder="$t('Placeholder.__DateRange')",
                                        @click:clear="dates = []"
                                    )
                                v-date-picker(
                                    v-model="dates",
                                    @input="rangeDateMenu = dates.length == 2 ? false : true",
                                    range,
                                    :locale="$store.getters['account/language']() == 'tw' ? 'zn-tw' : ''"
                                )
                        v-col.text-right
                            v-btn(rounded, dark, @click="generateReport", color="primary", min-width="112") {{ $t('Reports.__GenerateReport') }}
        v-row(v-if="reportData")
            v-col.text-right.mx-4
                v-btn.ml-4(rounded, dark, color="#b4b9be", @click="downloadReportExcel") 
                    | {{ $t('ActionOption.__Export') }} EXCEL
                v-btn.ml-4(rounded, dark, color="#b4b9be", @click="downloadReportPDF") 
                    | {{ $t('ActionOption.__Export') }} PDF
        v-card#report-data.mt-4(v-if="reportData")
            v-card-text
                v-row
                    v-col(cols="12")
                        v-simple-table(dense)
                            template(v-slot:default)
                                thead
                                    tr
                                        th {{ $t('Reports.__AccountName') }}
                                        th.text-right {{ $t('Reports.__StartingBalance') }}
                                        th.text-right {{ $t('Reports.__Debit') }}
                                        th.text-right {{ $t('Reports.__Credit') }}
                                        th.text-right {{ $t('Reports.__NetMovement') }}
                                        th.text-right {{ $t('Reports.__EndingBalance') }}
                                tbody
                                    template(v-for="group in accountGroups")
                                        tr(style="background-color: #fdf1eb")
                                            td(colspan=6) {{ $t('AccountGroups.__' + group) }}
                                        tr(v-for="item in reportData[group]")
                                            td
                                                router-link(:to="getAccountTransactionUrl(item)", target="_blank")
                                                    .ml-2.primary--text {{ getAccountTranslatedName(item.name) }}
                                            td.text-right(v-if="groupsShowNetMovementOnly.includes(group)") 
                                            td.text-right(v-else) {{ getAmountWithCurrency(item.startingBalance, currencyCode) }}
                                            td.text-right {{ getAmountWithCurrency(item.debit, currencyCode) }}
                                            td.text-right {{ getAmountWithCurrency(item.credit, currencyCode) }}
                                            td.text-right {{ getAmountWithCurrency(item.netMovement, currencyCode) }}
                                            td.text-right(v-if="groupsShowNetMovementOnly.includes(group)") 
                                            td.text-right(v-else) {{ getAmountWithCurrency(item.endingBalance, currencyCode) }}
                                        tr
                                            td.font-weight-bold {{ $t('Reports.__Total') }}
                                            td.text-right(v-if="groupsShowNetMovementOnly.includes(group)") 
                                            td.font-weight-bold.text-right(v-else) {{ getAmountWithCurrency(groupTotal[group].startingBalance, currencyCode) }}
                                            td.font-weight-bold.text-right {{ getAmountWithCurrency(groupTotal[group].debit, currencyCode) }}
                                            td.font-weight-bold.text-right {{ getAmountWithCurrency(groupTotal[group].credit, currencyCode) }}
                                            td.font-weight-bold.text-right {{ getAmountWithCurrency(groupTotal[group].netMovement, currencyCode) }}
                                            td.text-right(v-if="groupsShowNetMovementOnly.includes(group)") 
                                            td.font-weight-bold.text-right(v-else) {{ getAmountWithCurrency(groupTotal[group].endingBalance, currencyCode) }}
                                        tr.no-hover
                                            td(colspan=6, style="border-bottom: 0px")
                                    tr
                                        td.font-weight-bold(style="border-bottom: 2px solid #e67339") {{ $t('Reports.__TotalForAllAccounts') }}
                                        td.font-weight-bold(style="border-bottom: 2px solid #e67339") 
                                        td.text-right.font-weight-bold(style="border-bottom: 2px solid #e67339") {{ getAmountWithCurrency(groupTotal['total'].debit, currencyCode) }}
                                        td.text-right.font-weight-bold(style="border-bottom: 2px solid #e67339") {{ getAmountWithCurrency(groupTotal['total'].credit, currencyCode) }}
                                        td.font-weight-bold(style="border-bottom: 2px solid #e67339") 
                                        td.font-weight-bold(style="border-bottom: 2px solid #e67339") 

        .no-data.mt-4.text-center.grey-darken-1--text(v-else) {{ $t('Table.__NoData') }}
</template>
<script>
import * as TimeHelper from "@/utils/timeHelper"
import * as AccountHelper from "@/utils/accountHelper"
import * as CurrencyHelper from "@/utils/currencies"
import { Workbook, boldRowText } from "@/utils/excelFileHelper"
import * as pdfFileHelper from "@/utils/pdfFileHelper"

export default {
  mixins: [TimeHelper.mixin, AccountHelper.mixin, CurrencyHelper.mixin],

  data() {
    return {
      title: this.$t("Reports.__AccountBalances"),
      formValid: false,
      dates: [],
      rangeDateMenu: false,
      dateRangeSelect: null,
      accountId: "",
      reportData: null,
      currencyCode: "TWD",
      accountGroups: ["Assets", "Liabilities", "Income", "OperatingExpenses", "OperatingCosts", "OwnersEquity"],
      groupsShowNetMovementOnly: ["Income", "OperatingExpenses", "OperatingCosts"],
      groupTotal: null,
      headers: [
        this.$t("Reports.__AccountName"),
        this.$t("Reports.__StartingBalance"),
        this.$t("Reports.__Debit"),
        this.$t("Reports.__Credit"),
        this.$t("Reports.__NetMovement"),
        this.$t("Reports.__EndingBalance")
      ]
    }
  },
  computed: {
    dateRangeText() {
      return this.dates
        .slice()
        .sort()
        .join(" ~ ")
    },
    filename() {
      return this.title + "_" + this.dates[0] + "_" + this.dates[1]
    }
  },
  watch: {
    dateRangeSelect(item) {
      if (item.text != this.$t("Reports.__Custom")) {
        this.dates = [item.from, item.to]
      }
    }
  },
  methods: {
    generateReport() {
      this.reportData = null
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("reports/getAccountBalances", {
          from: this.dates[0],
          to: this.dates[1]
        })
        .then(
          function(response) {
            this.reportData = {}
            this.groupTotal = {}
            this.accountGroups.map(item => {
              this.reportData[item] = []
              this.groupTotal[item] = {
                credit: 0,
                debit: 0,
                netMovement: 0,
                startingBalance: 0,
                endingBalance: 0
              }
            })
            this.groupTotal["total"] = {
              credit: 0,
              debit: 0,
              netMovement: 0,
              startingBalance: 0,
              endingBalance: 0
            }
            var accountBalances = response.data.accountBalances
            accountBalances.map(item => {
              var group = item.group
              this.reportData[group].push(item)
              this.groupTotal[group]["credit"] += item["credit"]
              this.groupTotal[group]["debit"] += item["debit"]
              this.groupTotal[group]["netMovement"] += item["netMovement"]
              this.groupTotal[group]["startingBalance"] += item["startingBalance"]
              this.groupTotal[group]["endingBalance"] += item["endingBalance"]
              this.groupTotal["total"]["credit"] += item["credit"]
              this.groupTotal["total"]["debit"] += item["debit"]
              this.groupTotal["total"]["netMovement"] += item["netMovement"]
              this.groupTotal["total"]["startingBalance"] += item["startingBalance"]
              this.groupTotal["total"]["endingBalance"] += item["endingBalance"]
            })
            // this.reportData = response.data
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    downloadReportExcel() {
      var filename = this.filename + ".xlsx"

      const workbook = new Workbook()
      for (var group of this.accountGroups) {
        var sheetName = this.$t("AccountGroups.__" + group)
        var worksheet = workbook.addWorksheet(sheetName)
        worksheet.addRow([this.$store.getters["bizes/biz"]().name])
        worksheet = this.translate2ExcelData(worksheet, this.headers, group, this.reportData[group])
      }

      var sheetNameTotal = this.$t("Reports.__TotalForAllAccounts")
      var worksheetTotal = workbook.addWorksheet(sheetNameTotal)
      worksheetTotal.addRow([this.$store.getters["bizes/biz"]().name])
      boldRowText(worksheetTotal.addRow(this.headers))
      worksheetTotal.addRow([
        this.$t("Reports.__TotalForAllAccounts"),
        "",
        this.groupTotal["total"].debit,
        this.groupTotal["total"].credit
      ])

      workbook.download(filename)
    },
    translate2ExcelData(worksheet, headers, group, groupData) {
      boldRowText(worksheet.addRow(headers))

      for (var item of groupData) {
        var row = []
        row.push(this.getAccountTranslatedName(item.name))
        row.push(this.groupsShowNetMovementOnly.includes(group) ? "" : this.getAmountWithCurrency(item.startingBalance))
        row.push(this.getAmountWithCurrency(item.debit))
        row.push(this.getAmountWithCurrency(item.credit))
        row.push(this.getAmountWithCurrency(item.netMovement))
        row.push(this.groupsShowNetMovementOnly.includes(group) ? "" : this.getAmountWithCurrency(item.endingBalance))
        worksheet.addRow(row)
      }
      var totalRow = []
      totalRow.push(this.$t("Reports.__Total"))
      totalRow.push(
        this.groupsShowNetMovementOnly.includes(group) ? "" : this.getAmountWithCurrency(this.groupTotal[group].startingBalance)
      )
      totalRow.push(this.getAmountWithCurrency(this.groupTotal[group].debit))
      totalRow.push(this.getAmountWithCurrency(this.groupTotal[group].credit))
      totalRow.push(this.getAmountWithCurrency(this.groupTotal[group].netMovement))
      totalRow.push(
        this.groupsShowNetMovementOnly.includes(group) ? "" : this.getAmountWithCurrency(this.groupTotal[group].endingBalance)
      )
      boldRowText(worksheet.addRow(totalRow))

      return worksheet
    },
    downloadReportPDF() {
      var filename = this.filename + ".pdf"
      var content = []

      //pdf
      content.push(pdfFileHelper.pdfTitle(this.$store.getters["bizes/biz"]().name))

      var idx = 0
      for (var group of this.accountGroups) {
        if (idx == 0) content.push(pdfFileHelper.pdfHeader(this.title + " - " + this.$t("AccountGroups.__" + group)))
        else content.push(pdfFileHelper.pdfHeader(this.title + " - " + this.$t("AccountGroups.__" + group), true))
        content.push(this.dates[0] + " ~ " + this.dates[1])
        var tableBody = this.translate2PDFData(Array.from(this.headers), group, this.reportData[group])
        content.push(pdfFileHelper.pdfTableSimple(tableBody))
        idx++
      }
      //total
      content.push(pdfFileHelper.pdfHeader(this.title + " - " + this.$t("Reports.__TotalForAllAccounts"), true))
      content.push(this.dates[0] + " ~ " + this.dates[1])
      var tableBodyTotal = []
      var tableHeadersTotal = []
      for (var header of this.headers) {
        tableHeadersTotal.push(pdfFileHelper.pdfTableHeader(header))
      }
      tableBodyTotal.push(tableHeadersTotal)
      tableBodyTotal.push([
        pdfFileHelper.pdfBoldText(this.$t("Reports.__TotalForAllAccounts")),
        "",
        pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal["total"].debit, this.currencyCode)),
        pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal["total"].credit, this.currencyCode)),
        "",
        ""
      ])
      content.push(pdfFileHelper.pdfTableSimple(tableBodyTotal))

      pdfFileHelper.downloadPDF(filename, content, "landscape")
    },
    translate2PDFData(headers, group, groupData) {
      var tableBody = []
      var tableHeaders = []
      for (var header of headers) {
        tableHeaders.push(pdfFileHelper.pdfTableHeader(header))
      }
      tableBody.push(tableHeaders)

      for (var item of groupData) {
        var row = []
        row.push(this.getAccountTranslatedName(item.name))
        row.push(
          this.groupsShowNetMovementOnly.includes(group)
            ? ""
            : this.getAmountWithCurrency(item.startingBalance, this.currencyCode)
        )
        row.push(this.getAmountWithCurrency(item.debit, this.currencyCode))
        row.push(this.getAmountWithCurrency(item.credit, this.currencyCode))
        row.push(this.getAmountWithCurrency(item.netMovement, this.currencyCode))
        row.push(
          this.groupsShowNetMovementOnly.includes(group) ? "" : this.getAmountWithCurrency(item.endingBalance, this.currencyCode)
        )
        tableBody.push(row)
      }
      var totalRow = []
      totalRow.push(pdfFileHelper.pdfBoldText(this.$t("Reports.__Total")))
      totalRow.push(
        this.groupsShowNetMovementOnly.includes(group)
          ? ""
          : pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal[group].startingBalance, this.currencyCode))
      )
      totalRow.push(pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal[group].debit, this.currencyCode)))
      totalRow.push(pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal[group].credit, this.currencyCode)))
      totalRow.push(pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal[group].netMovement, this.currencyCode)))
      totalRow.push(
        this.groupsShowNetMovementOnly.includes(group)
          ? ""
          : pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal[group].endingBalance, this.currencyCode))
      )
      tableBody.push(totalRow)
      console.log(totalRow)

      return tableBody
    },
    getAccountTransactionUrl(account) {
      return (
        "/" +
        this.$route.params.lang +
        "/reports/account-transactions?from=" +
        this.dates[0] +
        "&to=" +
        this.dates[1] +
        "&accountid=" +
        account.id
      )
    }
  },
  created() {
    var today = new Date()
    this.dates = [today.getFullYear() + "-01-01", this.getStringByFormat(today)]
    this.generateReport()
    this.currencyCode = this.$store.getters["bizes/currencyCode"]()
  }
}
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
</style>
